import React, { Fragment, useState, useEffect, useContext } from "react";
import Loading from "components/shared/Loading";
import Separator from "components/shared/Separator";
import Button from "components/shared/Button";
import Link from "components/shared/Link";
import useFetch from "hooks/useFetch";
import { Context } from "Context";
import { mapString } from "utils";
import useLocalStorage from "hooks/useLocalStorage";
import config from "config.json";
import Icon from "components/shared/Icon";
const oldMessagesProperty = "received-invitations";

const handleUndefined = (variable) => variable || "";

const NotificationsModalContent = (props) => {
	const [syndicatedDismissButton, setSyndicatedDismissButton] = useLocalStorage(
		"syndicatedDismissButton",
		false
	);
	const {
		headerData: {
			interstitial: { interstitialNotificationsModal },
		},
		profileData: { user },
	} = useContext(Context);
	const { messages, updateNotificationsAction } = props;
	const mainClass = "syndicated-notifications-modal";
	const [fetchTrigger, setFetchTrigger] = useState(0);
	const [optionParams, setOptionsParams] = useState(null);
	const [requestUrl, setRequestUrl] = useState("");
	const [invitationId, setInvitationId] = useState("");
	const { error } = useFetch(
		requestUrl ? requestUrl : "",
		optionParams,
		0,
		fetchTrigger
	);


	const renderNotificationTypesAndLinks = () => {
		const renderMessage = (content, webLink, messages = null) => {
			return (
				content && (
					<>
						{messages ? (
							messages.map((message, index) => (
								<li
									className={`${mainClass}__message-item guestSensitive`}
									key={index}
								>
									{mapString(
										content,
										`${message.sender?.name.firstName} ${message.sender?.name.lastName}`,
										`${message.toGuest?.name.firstName} ${message.toGuest?.name.lastName}`
									)}
								</li>
							))
						) : (
							<li className={`${mainClass}__message-item guestSensitive`}>
								{content}
							</li>
						)}

						<div className={`${mainClass}__message-link guestSensitive`}>
							{webLink && (
								<Link
									href={webLink?.href}
									title={webLink?.title}
									analyticsLinkId={webLink?.analyticsLinkId}
								/>
							)}
						</div>
					</>
				)
			);
		};
		return (
			<div className={`${mainClass}__messages-container`}>
				<ul className={`${mainClass}__message-wrapper`}>
					{messages.receivedInvitations?.hasNotifications &&
						renderMessage(
							interstitialNotificationsModal.invitationMessage,
							interstitialNotificationsModal.webLink[0]
						)}
					{messages.mergeRequests?.hasNotifications &&
						renderMessage(
							interstitialNotificationsModal.mergeRequestMessage,
							interstitialNotificationsModal.webLink[1],
							messages.mergeRequests.messages
						)}
					{messages.potentialDuplicates?.hasNotifications &&
						renderMessage(
							interstitialNotificationsModal.duplicateMessage,
							interstitialNotificationsModal.webLink[2]
						)}
				</ul>
			</div>
		);
	};

	const handleNotificationAction = (links, operationType) => {
		if (!operationType || !user?.swid) {
			return null;
		}
		let invId;
		const hrefData = links?.[operationType]?.href;
		const options = links?.[operationType]?.post;
		const apiUrl = config.profile.apiUrl;
		const friendXId = handleUndefined(hrefData?.split("/")[3]);
		const headers = {
			...options.headers,
			swid: user.swid,
			token: user.authToken,
		};
		setOptionsParams({
			method: "PUT",
			headers,
			body: JSON.stringify(options.body),
		});
		switch (operationType) {
			case "accept":
				invId = options?.body["invitation-id"];
				setRequestUrl(`${apiUrl}/${friendXId}/${operationType}/${invId}`);
				updateNotificationsAction(links.self.href);
				setFetchTrigger((fetch) => fetch + 1);
				break;
			case "decline":
				invId = handleUndefined(hrefData?.split("/")[5]);
				setRequestUrl(`${apiUrl}/${friendXId}/${operationType}/${invId}`);
				updateNotificationsAction(links.self.href);
				setFetchTrigger((fetch) => fetch + 1);
				break;
			default:
				return null;
		}
		invId && setInvitationId(invId);
		return true;
	};
	const toggleElement = (elems) => {
		const elemsArray = elems.split(" ");
		elemsArray.forEach((item) => {
			const toggleElem = document.querySelector(item);
			toggleElem.classList.toggle(`${mainClass}--hidden`);
		});
		if (elems.indexOf(".top") >= 0) {
			setSyndicatedDismissButton(true);
		}
	};
	useEffect(() => {
		if (
			error &&
			invitationId &&
			interstitialNotificationsModal?.familyFriendsErrorLink?.href
		) {
			window.location.assign(
				`${interstitialNotificationsModal.familyFriendsErrorLink.href}${invitationId}/`
			);
		}
	}, [error, invitationId, interstitialNotificationsModal]);

	const isOldMessagesStructure = messages?.[0]?.[oldMessagesProperty];

	return (
		<Fragment>
			<div className={`${mainClass}__title-bar`}>
				<h1>{interstitialNotificationsModal.title}</h1>
			</div>
			<div className={`${mainClass}__container ${mainClass}__container--top`}>
				{!isOldMessagesStructure ? (
					<Fragment>
						<div className={`${mainClass}__messages-list`}>
							{messages ? renderNotificationTypesAndLinks() : <Loading />}
						</div>
						<Button
							className={`${mainClass}__icon-check-out`}
							onClick={props.action}
							analyticsLinkId={
								interstitialNotificationsModal.secondaryButtonAnalyticsLinkId
							}
						>
							<Icon icon={"icon_close-reversed"} />
						</Button>
					</Fragment>
				) : (
					<Fragment>
						<ul className={`${mainClass}__messages-list`}>
							{messages[0] ? (
								messages[0][oldMessagesProperty]?.map((message, index) => (
									<li
										className={`${mainClass}__message-item guestSensitive`}
										key={index}
									>
										{mapString(
											interstitialNotificationsModal.invitationMessage,
											`${message.issuedBy.firstName} ${message.issuedBy.lastName}`
										)}
										<div className={`${mainClass}__option-links`}>
											<button
												className={`${mainClass}__button`}
												onClick={() =>
													handleNotificationAction(message.links, "accept")
												}
												tabIndex={0}
											>
												{interstitialNotificationsModal.invitationAccept}
											</button>
											{" | "}
											<button
												className={`${mainClass}__button`}
												onClick={() =>
													handleNotificationAction(message.links, "decline")
												}
												tabIndex={0}
											>
												{interstitialNotificationsModal.invitationDecline}
											</button>
										</div>
									</li>
								))
							) : (
								<Loading />
							)}
						</ul>
						<button
							className={`${mainClass}__show-hide-legal-disclaimer ${mainClass}__button`}
							onClick={() => toggleElement(`.${mainClass}__legal-disclaimer`)}
							tabIndex={0}
						>
							{interstitialNotificationsModal.showHideLegalDisclaimer}
						</button>
						<div
							className={`${mainClass}__legal-disclaimer ${mainClass}--hidden`}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: interstitialNotificationsModal.legalDisclaimer,
								}}
							></div>
						</div>
						{!syndicatedDismissButton && (
							<Fragment>
								<div
									className={`${mainClass}__separator ${mainClass}__separator--top`}
								>
									<Separator horizontal />
								</div>
								<div className={`${mainClass}__footer`}>
									<div className={`${mainClass}__dismiss-text`}>
										<div
											className={`${mainClass}__dismiss-text ${mainClass}__dismiss-text--description`}
											dangerouslySetInnerHTML={{
												__html: interstitialNotificationsModal.description,
											}}
										></div>{" "}
										{interstitialNotificationsModal.webLink && (
											<Link
												href={interstitialNotificationsModal.webLink?.href}
												title={interstitialNotificationsModal.webLink?.title}
											/>
										)}
									</div>
									<div className={`${mainClass}__dismiss-button`}>
										<button
											className={`modal-dismiss-link ${mainClass}__button`}
											onClick={() =>
												toggleElement(`.${mainClass}__footer .top`)
											}
											tabIndex={0}
										>
											{interstitialNotificationsModal.dismiss}
										</button>
									</div>
								</div>
							</Fragment>
						)}
					</Fragment>
				)}
			</div>
			<div
				className={`${mainClass}__container ${mainClass}__container--bottom${
					messages.receivedInvitations?.hasNotifications && "--newConnectionsModal"
				}`}
			>
				<div
					className={`${mainClass}__separator ${mainClass}__separator--bottom`}
				>
					<Separator horizontal />
				</div>

				<div className={`${mainClass}__modal-buttons`}>
					<Button
						className={`${mainClass}__button-check-out`}
						onClick={props.action}
						title={interstitialNotificationsModal.secondaryButton}
						analyticsLinkId={
							interstitialNotificationsModal.secondaryButtonAnalyticsLinkId
						}
					/>
				</div>
			</div>
		</Fragment>
	);
};

export default NotificationsModalContent;
